<svelte:head>

<script  src="https://cdnjs.cloudflare.com/ajax/libs/pivottable/2.13.0/pivot.min.js"
			  on:load={pivottableLoaded}
			  crossorigin="anonymous"
			  defer>
  </script>  
<!-- <script  src="../dist/novix.pivottable.js"
			  crossorigin="anonymous"
			  defer>
  </script>  -->
  <script  src="../dist/highstock.js"
			  on:load={highstockLoaded}
			  crossorigin="anonymous"
			  defer>
  </script>  
    <script  src="../dist/highcharts-more.js"
			  on:load={highchartsLoaded}
			  crossorigin="anonymous"
			  defer>
  </script>  
 <script  src="../dist/modules/treemap.js"
			  on:load={treemapLoaded}
			  crossorigin="anonymous"
			  defer>
  </script>  
<!--   <script  src="../dist/handsontable.full.min.js"
			  on:load={handsontableLoaded}
			  crossorgin="anonymous"
			  defer>
  </script>   -->
<!--    <script  src="../dist/novix.pivot.renderer.js"
			  on:load={novixpivotrendererLoaded}
			  crossorigin="anonymous"
			  defer>
  </script>   -->
   <script  src="../dist/hightchart_renderers.js"
			  on:load={highchartrendererLoaded}
			  crossorigin="anonymous"
			  defer>
  </script>
  <script  src="../dist/subtotal.js"
			  on:load={subtotalrendererLoaded}
			  crossorigin="anonymous"
			  defer>
  </script>  

<link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/pivottable/2.13.0/pivot.min.css" />
<!-- <link rel="stylesheet" media="screen" href="../dist/novix.pivotttable.css" /> -->
<link rel="stylesheet" type="text/css" href="../dist/subtotal.min.css" />
<!-- <link rel="stylesheet" media="screen" href="../dist/handsontable.full.min.css" /> -->
<!-- <link rel="stylesheet" media="screen" href="../dist/pivottable_novixpivotjs_style.css" /> -->

</svelte:head>

<script>

export let data = [];

import { onMount, onDestroy } from 'svelte';

	onMount(async () => {
		  
	});

  var is_dependenciesLoaded = false;
  function dependenciesLoaded() {
  		if (   true 
  		       && is_pivottableLoaded 
  		       && is_highstockLoaded 
  		       && is_highchartsLoaded 
  		       && is_treemapLoaded 
  		       && is_highchartrendererLoaded 
  		       && is_subtotalrendererLoaded 
//  		       && is_dataLoaded 
  		   )
  	  {
			is_dependenciesLoaded = true;
//			setTimeout(function(){ 
				buildComponent();
//			 }, 
//			 1000); // NASTY HACK: to wait until DOM is processed

  		}
  }

  var is_subtotalrendererLoaded = false;
  function subtotalrendererLoaded() {
		// The external javascript library is ready.
		is_subtotalrendererLoaded = true;
		dependenciesLoaded();
  }

  var is_highchartrendererLoaded = false;
  function highchartrendererLoaded() {
		// The external javascript library is ready.
		is_highchartrendererLoaded = true;
		dependenciesLoaded();
  }

  var is_treemapLoaded = false;
  function treemapLoaded() {
		// The external javascript library is ready.
		is_treemapLoaded = true;
		dependenciesLoaded();
  }

  var is_highchartsLoaded = false;
  function highchartsLoaded() {
		// The external javascript library is ready.
		is_highchartsLoaded = true;
		dependenciesLoaded();
  }

  var is_highstockLoaded = false;
  function highstockLoaded() {
		// The external javascript library is ready.
		is_highstockLoaded = true;
		dependenciesLoaded();
  }

  var is_pivottableLoaded = false;
  function pivottableLoaded() {
		// The external javascript library is ready.
		is_pivottableLoaded = true;
		dependenciesLoaded();
  }


  function buildComponent() {
  			console.log(window.jQuery);
			console.log(jQuery);

			console.log(jQuery.pivotUtilities.subtotal_renderers);
			console.log(jQuery.pivotUtilities.highchart_renderers);

	        var dataClass = jQuery.pivotUtilities.SubtotalPivotData;

				var renderers = jQuery.extend({},
//															jQuery.pivotUtilities.novix_renderers, 
															jQuery.pivotUtilities.subtotal_renderers,
															jQuery.pivotUtilities.highchart_renderers,
														);
			
				jQuery("#pivot").pivotUI(data, {
		         dataClass: dataClass,
					rows: ["Party","Province"],
					cols: ["Age","Gender"],
					renderers: renderers,
		                rendererName: "Table With Subtotal",
					rendererOptions: {
						onEditValues: function (changes) {
//										jQuery(".changesOutput").html(JSON.stringify(changes));
                        },
						onDrawTable: function (htTable) {
//                            jQuery(".changesOutput").empty();
                        },
					}
				});

  }

</script>

<style>
</style>


<div class="diagramWrapper">
	<div id="pivot" class="pane"></div>
</div>

	{#if is_dependenciesLoaded}
   &nbsp;

	{:else}
   &nbsp;

	{/if}


